const isInternationalAchCompany = company =>
    company.secCodes.some(code => code.code.toLowerCase() === 'iat');
export default isInternationalAchCompany;
